import { useMutation } from '@tanstack/react-query';
import { showBidCustomerPhone } from '../api';

type Props = {
  userId: number | string | undefined;
  phone?: string | null;
  className?: string;
};

/** Phone number, or a «Показать» button that reveals it via `user/profile/show-phone/`. */
export const PhoneCell = ({ userId, phone, className }: Props) => {
  const reveal = useMutation({
    mutationFn: () => showBidCustomerPhone(userId ?? ''),
  });
  const shown = phone || (reveal.data?.success === 1 ? reveal.data.phone : '');

  if (shown) return <span className={className}>{shown}</span>;
  return (
    <button
      type="button"
      className={`btn btn-primary btn-sm ${className ?? ''}`}
      disabled={!userId || reveal.isPending}
      onClick={() => reveal.mutate()}
    >
      Показать
    </button>
  );
};
